module.exports = __webpack_public_path__ + "static/media/cricket-live.650cd07c.svg";